<template>
  <div :id="this.$route.name">
    <form @submit.prevent="this.$ValidForm(this)">
      <div class="card text-center">
        <div class="card-header" :class="ThemeTitleModal">
          <ul
            class="nav nav-tabs mt-3 card-header-tabs"
            id="myTab"
            role="tablist"
            dir="rtl"
          >
            <li class="nav-item">
              <a
                class="nav-link active"
                id="Detail-tab"
                data-toggle="tab"
                href="#Detailtab"
                role="tab"
                aria-controls="Detailtab"
                aria-selected="true"
                >سیستم های اطلاعاتی</a
              >
            </li>
          </ul>
        </div>
        <div class="tab-content" id="Controler">
          <div
            class="tab-pane fade show active"
            id="Detailtab"
            role="tabpanel"
            aria-labelledby="Detail-tab"
          >
            <div id="Controler">
              <div class="container mt-3 mb-3 text-right">
                <div class="row">
                  <div class="col-lg-3 col-12">
                    <small>نسخه سیستم</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.SysVersion"
                    />
                  </div>
                  <div class="col-lg-6 col-12 text-right">
                    <small>نسخه بانک اطلاعاتی</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.Dbversion"
                    />
                  </div>
                  <div class="col-lg-3 col-12 text-right">
                    <small>تجمیعی</small>
                    <span class="form-control p-1">
                      <div class="custom-control custom-switch">
                        <input
                          type="checkbox"
                          class="custom-control-input InputText"
                          id="Tajmie"
                          @click="statusChk($event)"
                          :value="Tajmie"
                        />
                        <label class="custom-control-label" for="Tajmie"
                          >تجمیعی</label
                        >
                      </div>
                    </span>
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-6 col-12 text-right">
                    <small>نام نرم افزار</small>
                    <select class="form-control required" v-model="Selected">
                      <option value="-1">
                        <span> نام نرم افزار را انتخاب کنید</span>
                      </option>
                      <option
                        v-for="item in this.$store.state.DefineInfoSystem
                          .DataSoftWare"
                        :key="item.Id"
                        :value="item.Id"
                      >
                        <span>{{ item.SoftName }}</span>
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-6 col-12 text-right">
                    <small>نام سیستم های اطلاعاتی</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.Dbname"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-6 col-12 text-right">
                    <small>نام بانک سیستم</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.SystemName"
                    />
                  </div>
                  <div class="col-lg-6 col-12 text-right">
                    <small>نام بانک تصاویر</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.ImageDbname"
                    />
                  </div>
                </div>
                <div class="row mt-3">
                  <div class="col-lg-6 col-12 text-right">
                    <small>نام بانک رویداد ها</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.LogDbname"
                    />
                  </div>
                  <div class="col-lg-6 col-12 text-right">
                    <small>نام بانک اینترنت بانک</small>
                    <input
                      type="text"
                      class="form-control InputText required"
                      v-model="DataAxios.WebDbname"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <button-save-data
          class="mb-3 mr-2"
          :DataParanet="DataAxios"
        ></button-save-data>
        <div v-for="Dataa in Data" :key="Dataa.id"></div>
      </div>
    </form>
  </div>
</template>
<script>
import ButtonSaveData from "../Tools/ButtonSaveData.vue";
export default {
  components: { ButtonSaveData },
  data() {
    return {
      Theme: "bg-BlueGreen",
      DataAxios: null,
      Data: this.$store.state.DefineInfoSystem.Data,
      InnerData: {
        ArryfildValue: null,
        Method: "get",
        Action: "CmbSoftware",
        Token: this.$session.get("Token"),
        From: "Body",
        Loc: this.$store.state.DefineInfoSystem.DataSoftWare,
      },
    };
  },
  computed: {
    ThemeTitleModal() {
      return this.$store.state.ThemeModal;
    },
    Selected: {
      get() {
        return this.$store.state.DefineInfoSystem.Data[0].TblSoftwareId;
      },
      set(value) {
        this.$store.state.DefineInfoSystem.Data[0].TblSoftwareId = value;
      },
    },
    Tajmie: {
      get() {
        return this.$store.state.DefineInfoSystem.Data[0].Tajmie;
      },
      set(value) {
        this.$store.state.DefineInfoSystem.Data[0].Tajmie = value;
      },
    },
  },
  methods: {
    statusChk: function (event) {
      var targetId = event.currentTarget.id;
      var checkBox = document.getElementById(targetId);
      if (checkBox.id == "Tajmie") {
        if (checkBox.checked == true) {
          this.$store.state.DefineInfoSystem.Data.Tajmie = true;
        } else {
          this.$store.state.DefineInfoSystem.Data.Tajmie = false;
        }
      }
    },
  },
  created() {
    let info;
    let list = [];
    for (let index = 0; index < this.Data.length; index++) {
      info = this.Data[index];
      list.push(info);
    }
    this.$myAxiosGetSoftware(this.InnerData);
    this.DataAxios = list[0];
  },
};
</script>
<style scoped>
.bg-DefModal {
  background: #566787;
}
</style>
